<template>
  <v-dialog v-model="dialog" max-width="500" persistent v-if="dialog">
    <v-card>
      <v-card-title class="headline">Establecer saldo</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <p> Introduce el monto de saldo para establecerle a {{ user.name }}. </p>

        <v-text-field
            v-model="balance"
            label="Otro monto"
            outlined
            dense
            type="number"
            prefix="$"
            :rules="[rules.min, rules.max]"
            min="0"
            max="10000"
        ></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <CancelButton :isDisabled="isLoading" @click="handleClose"/>
        <CreateButton
            :isDisabled="!isValidAmount()"
            :isLoading="isLoading"
            @click="openConfirmationDialog"
            label="Establecer saldo"
            icon="mdi-cash-edit"
        />
      </v-card-actions>
    </v-card>

    <DialogConfirmation
        :message="`¿Estás seguro de que deseas establecer en $${balance} el saldo de ${user.name}?`"
        @ok="handleSetBalance"
        ref="dialogConfirmation"
    />

  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import throwSuccessMessage from "@/utils/SuccessMessage";
import UserService from "@/services/users/UserService";
import DialogConfirmation from "@/components/DialogConfirmation.vue";
import {RequestChangeBalance} from "@/services/users/entities/RequestChangeBalance";
import CancelButton from "@/components/buttons/CancelButton.vue";
import CreateButton from "@/components/buttons/CreateButton.vue";

export default Vue.extend({
  name: "DialogAddBalance",
  components: {CreateButton, CancelButton, DialogConfirmation},
  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      // Balance
      balance: 0 as number,

      // Validation
      rules: {
        min: (v: number) => (v && v > -1) || "Monto inválido",
        max: (v: number) => (v && v <= 10000) || "El monto máximo es $10,000",
      },

      // Dialog
      dialog: false as boolean,
      isLoading: false as boolean,
    };
  },

  methods: {
    isValidAmount() {
      return this.balance > 0 && this.balance <= 10000;
    },

    openConfirmationDialog() {
      (this.$refs.dialogConfirmation as any).dialog = true;
    },

    async handleSetBalance() {
      this.isLoading = true;
      try {
        const body: RequestChangeBalance = {
          username: this.user.username,
          amount: this.balance,
        }
        await UserService.setBalance(body);
        throwSuccessMessage("Saldo establecido correctamente");
        this.$emit("updateBalance");
      } finally {
        this.isLoading = false;
        this.handleClose();
      }
    },

    handleClose() {
      this.balance = 0;
      this.isLoading = false;
      this.dialog = false;
    },
  },
});
</script>
